const Masonry = require('masonry-layout');

export default {
  init() {
    // JavaScript to be fired on the home page
    new Masonry('.masonry', {
      itemSelector: '.masonry-item',
      columnWidth: '.masonry-sizer',
      gutter: '.gutter-sizer',
      percentPosition: true,
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js